import React from "react";
import Routes from "./styles/Routes";

function App() {
  return <Routes />;
}

export default App;
